import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/rootState'

export default function MqBeforeLarge(props) {
  const size = useSelector((state: RootState) => state.mq.size)
  return ['s', 'm'].includes(size) ? props.children : null
}
